import { footerGroups } from '@/mocks/exposure';

const submitActions = [
  { icon: 'ri-upload-cloud-2-line', label: '上传素材', desc: '截图 · 记录 · 音视频' },
  { icon: 'ri-exchange-funds-line', label: '补充证据', desc: '时间线 · 语境佐证' },
  { icon: 'ri-error-warning-line', label: '申请纠错', desc: '被误伤 · 自证材料' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-50 pt-4 md:pt-8">
      {/* 投稿/纠错 CTA 条 */}
      <section id="submit" className="mx-auto w-full max-w-[1280px] px-4 pb-4 md:px-6">
        <div className="overflow-hidden rounded-2xl bg-foreground-950">
          <div className="grid items-center gap-6 p-6 md:grid-cols-2 md:p-9">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-megaphone-line" /> 投稿与查证通道
              </span>
              <h3 className="mt-4 font-serif text-2xl font-black leading-tight text-background-50 md:text-3xl">
                有一手材料？这里集中接收、核验、归档
              </h3>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-300">
                上传截图、聊天记录、录音视频或文件材料，交由查证组逐条核验来源与语境后再统一收录。
                被不实内容误伤的一方，同样可通过纠错通道提交自证材料。
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {submitActions.map((a, i) => (
                <a
                  key={i}
                  href="#"
                  className="group flex items-center gap-4 rounded-xl border border-background-100/15 bg-background-100/5 p-4 transition hover:border-accent-400/50 hover:bg-background-100/10"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-xl text-background-50">
                    <i className={a.icon} />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-serif text-base font-bold text-background-50">
                      {a.label}
                    </span>
                    <span className="block text-xs text-background-400">{a.desc}</span>
                  </span>
                  <i className="ri-arrow-right-up-line text-xl text-background-400 transition group-hover:text-accent-300" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 页脚运营壳 */}
      <div className="bg-primary-950 text-background-100">
        <div className="mx-auto grid w-full max-w-[1280px] gap-8 px-4 py-10 md:px-6 md:py-14 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-lg text-background-50">
                <i className="ri-spy-line" />
              </span>
              <span className="font-serif text-xl font-black tracking-wide text-background-50">
                全网黑料
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              集中查证全网黑料实锤：证据截图、聊天记录、录音视频与文件材料持续更新归档，逐件核验来源与语境，便于快速对照与汇总。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-400">
              <i className="ri-checkbox-circle-line text-accent-400" />
              材料均脱敏 · 保留来源语境 · 可申请纠错
            </div>
          </div>

          {footerGroups.map((g) => (
            <div key={g.title}>
              <h4 className="text-sm font-bold tracking-wide text-background-50">{g.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {g.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      className="inline-flex items-center gap-1.5 text-sm text-background-300 transition hover:text-accent-300"
                    >
                      <i className="ri-arrow-right-s-line text-xs text-primary-300" />
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-100/10">
          <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
            <span>本站内容为版式演示素材，均虚构示例，不指向任何真实个人。</span>
            <span className="inline-flex items-center gap-4">
              <a href="#" className="transition hover:text-accent-300">免责声明</a>
              <a href="#" className="transition hover:text-accent-300">隐私与纠错</a>
              <span className="hidden sm:inline">© {new Date().getFullYear()} 全网黑料</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}